import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import UnifyCustomerProfileImage from './UnifyCustomerProfileImage'

const copy = {
  heading: `Unify your customer profile`,
  description: `Create a complete, unified picture of your customer, including predictions on how and why they interact, for better engagement.`,
}

const link = {
  text: `Explore Unify`,
  url: `/product/unify/`,
}

const UnifyCustomerProfile = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="2Col" reverse={true}>
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <UnifyCustomerProfileImage />
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default UnifyCustomerProfile
